import React, { FC, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Routes, useLocation } from 'react-router-dom';
import { useLoader } from 'components/Layout/LoadingPage';
import * as Sentry from '@sentry/react';

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

export const RouteTransition: FC<React.PropsWithChildren> = ({ children }) => {
  const loader = useLoader();
  const { pathname } = useLocation();

  const isVisited = loader.isVisited(pathname);

  useEffect(() => {
    if (!isVisited) {
      loader.register(pathname);
    }
  }, []);

  const pageMotion = {
    animate: { opacity: 1, transition: { delay: !isVisited ? 0.9 : 0, duration: 0.4 } },
    exit: { opacity: 0, transition: { duration: 0.2 } },
  };

  return (
    <motion.div
      key={pathname}
      initial={false}
      animate="animate"
      exit="exit"
      variants={pageMotion}
      className="route-transition"
      style={{ height: '100%', opacity: 0 }}
    >
      {children}
    </motion.div>
  );
};

export const AnimatedRoutes: FC<React.PropsWithChildren> = ({ children }) => {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <SentryRoutes location={location} key={location.pathname}>
        {children}
      </SentryRoutes>
    </AnimatePresence>
  );
};
